import Page from "components/common/page/Page";

const AgricultureMaintenanceHomePage = () => {
    return (
        <Page title="pages.agriculture.work.maintenance.home">
            <div>Agriculture Maintenance over view data</div>
        </Page>
    );
};

export default AgricultureMaintenanceHomePage;
